// Golf 8: Texte der Web-App für den täglichen Check-in und den Familienkreis. Du-Form, ruhig;
// nie als Alarm. POORT: moedertaalreview vóór livegang.
export const appCareDe = {
    nav: 'Check-in und Kreis',
    notForRelative: 'Diese Seite ist nicht für Mitschauende.',
    account: 'Konto',
    viaBoard: '(Ja auf der Tafel gesagt)',
    viaApp: '(Ja in der App gesagt)',
    subjectLabel: 'Wer tippt jeden Tag?',
    removed: '{label} wurde aus dem Kreis genommen.',
    left: 'Du hast den Kreis verlassen.',
    comingSoon: 'Der tägliche Check-in und der Familienkreis kommen bald. Tafel, Kalender und Erinnerungen funktionieren schon jetzt.',
    wizardSeniorLine: 'Schaut später Familie mit? Das schaltest du unter Einstellungen, Check-in und Kreis ein.',
    setupSaved: 'Der Check-in ist bereit.',
    circleOn: 'Familie mitschauen lassen',
    personRights: 'Rechte von {label}',
    managerSeesAll: 'Verwaltet die Tafel und sieht alles.',
    noReachSave: 'Einschalten geht erst, wenn jemand einen Hinweis bekommen kann.',
    consentLaterWizard: 'Der Check-in startet erst, wenn {name} auf der Tafel Ja sagt.',
    title: 'Check-in und Kreis',
    settingsBody: "Ein großer Knopf 'Alles gut' auf der Tafel, und Familie, die aus der Ferne mitschaut.",
    widgetTitle: 'Täglicher Check-in',
    setupTitle: 'So bleibt ihr in Kontakt',
    setupIntro: "Jeden Tag tippt {name} einmal auf 'Alles gut'. Bleibt das aus, bekommt die Familie einen ruhigen Hinweis.",
    whoUsesBoard: 'Wer benutzt die Tafel?',
    boardSelf: 'Ich selbst',
    boardOther: 'Jemand anderes',
    otherName: 'Wie heißt diese Person?',
    otherNamePlaceholder: 'Zum Beispiel Mama',
    ownerHidden: 'Du wirst auf der Tafel nicht angezeigt.',
    capacityQ: 'Kann {name} das selbst entscheiden?',
    capacityYes: 'Ja',
    capacityNoButton: 'Nein',
    capacityNo: 'Dann können wir den Check-in noch nicht einschalten. {name} muss selbst Ja sagen können. Tafel und Kalender funktionieren wie gewohnt.',
    checkInToggle: 'Täglicher Check-in',
    deadline: 'Spätestens um',
    days: 'An diesen Tagen',
    dayNames: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
    grace: 'Hinweis nach',
    graceMin: '{n} Minuten',
    whoFollows: 'Wer schaut mit?',
    whoFollowsHint: 'Alle bekommen eine E-Mail. Danach sagt {name} auf der Tafel, ob das okay ist.',
    inviteEmail: 'E-Mail-Adresse',
    inviteLabel: 'Wie nennt {name} dich?',
    inviteLabelOther: 'Wie nennt {name} diese Person?',
    addPerson: 'Noch jemand',
    rightAlerts: "Hinweis, wenn 'Alles gut' ausbleibt",
    rightAgenda: 'Kalender sehen (ohne private Termine)',
    invite: 'Einladen',
    invited: 'Einladung an {email} gesendet',
    later: 'Später',
    disclaimerTitle: 'Kein Notrufdienst',
    disclaimerBody: 'Der Check-in ist ein ruhiger Hinweis, kein Alarm. Er erkennt keinen Sturz und ruft keine Hilfe. Keine Nachricht heißt nicht immer, dass alles gut ist. Im Notfall rufst du 112.',
    disclaimerCheck: 'Ich verstehe, dass dies kein Notrufdienst ist.',
    selfConsentNow: 'Weil du die Tafel selbst benutzt, fragen wir hier nach deinem Ja.',
    otherConsentLater: 'Beim ersten Mal fragt die Tafel {name}, ob das okay ist. Bis dahin gibt es keinen Hinweis.',
    finish: 'Fertig',
    save: 'Speichern',
    saved: 'Gespeichert',
    cancel: 'Abbrechen',
    enable: 'Einschalten',
    disable: 'Ausschalten',
    reachTitle: 'Wer bekommt einen Hinweis?',
    reachOk: '{n} von {m} bekommen jetzt einen Hinweis.',
    reachNone: 'Niemand bekommt jetzt einen Hinweis.',
    reachNeedsInstall: '{label} muss AMUMIN zuerst zum Home-Bildschirm hinzufügen.',
    reachNoPush: '{label} hat Mitteilungen noch nicht eingeschaltet.',
    reachFailed: 'Der letzte Hinweis an {label} kam nicht an.',
    reachEnableFirst: 'Schalte zuerst Mitteilungen auf deinem Telefon ein. Danach kannst du den Check-in einschalten.',
    noReachInvited: 'Noch niemand kann einen Hinweis bekommen: {names} muss die Einladung noch annehmen. Danach kannst du den Check-in einschalten.',
    noReachYourYes: 'Noch niemand kann einen Hinweis bekommen: {names} wartet auf dein Ja (oben auf Heute). Danach kannst du den Check-in einschalten.',
    noReachTheirYes: 'Noch niemand kann einen Hinweis bekommen: {names} wartet auf das Ja von {name} auf der Tafel.',
    noReachPush: 'Noch niemand kann einen Hinweis bekommen: {names} muss zuerst Mitteilungen einschalten. Danach kannst du den Check-in einschalten.',
    noReachSelf: 'Noch niemand kann einen Hinweis bekommen. Lade jemanden zum Mitschauen ein; diese Person nimmt die Einladung an und schaltet Mitteilungen ein.',
    pendingOnTitle: 'Der Check-in ist noch aus',
    pendingOnReady: 'Jetzt kann jemand einen Hinweis bekommen ({n} von {m}). Du kannst den Check-in einschalten.',
    pendingOnButton: 'Check-in einschalten',
    pendingOnDone: 'Der Check-in ist an.',
    pushEnable: 'Mitteilungen auf diesem Telefon für das Zuhause von {name} einschalten',
    pushOpen: 'Mitteilungen einrichten',
    iosInstall: "Auf dem iPhone: tippe auf Teilen, dann 'Zum Home-Bildschirm', und öffne AMUMIN von dort.",
    waitConsent: 'Wartet auf das Ja von {name} auf der Tafel.',
    declined: '{name} möchte lieber nicht. Du kannst nach dem {date} erneut fragen.',
    askAgain: 'Auf der Tafel erneut fragen',
    activeSince: 'An seit {date}',
    stoppedGone: '{name} gehört nicht mehr zu diesem Haushalt. Der Check-in ist aus.',
    stoppedBySelf: '{name} hat den Check-in selbst ausgeschaltet. Du kannst erneut fragen lassen.',
    orphanTitle: 'Du gehörst zu keinem Zuhause mehr',
    orphanBody: 'Du schaust nirgends mehr mit und bist kein Mitglied eines Haushalts. Dein Konto bleibt, bis du es selbst löschst.',
    orphanAccount: 'Konto',
    orphanLogout: 'Abmelden',
    stateDone: "{name} hat um {time} auf 'Alles gut' getippt.",
    stateWaiting: 'Noch nicht. Spätestens {time}.',
    stateDue: 'Noch nicht. {name} kann noch tippen.',
    stateMissing: "Heute noch kein 'Alles gut' von {name}.",
    stateMissingEarlier: "Gestern ({date}) kam kein 'Alles gut' von {name}.",
    stateBoardOffline: 'Die Tafel ist seit {time} offline, daher kann {name} vielleicht nicht tippen.',
    stateNoBoard: 'Es ist keine Tafel gekoppelt.',
    stateResolved: 'Doch alles in Ordnung: {name} hat um {time} getippt.',
    stateResolvedOffline: 'Doch alles in Ordnung: {name} hat um {time} getippt (die Tafel war offline).',
    stateResolvedManual: '{label}: alles in Ordnung ({time}).',
    stateNotChecked: 'Heute konnten wir nicht prüfen (Störung bei AMUMIN). Schau bitte selbst kurz nach.',
    stateDegraded: 'Wir prüfen gerade nicht (Störung).',
    statePaused: 'Pause bis einschließlich {date} (gesetzt von {label}).',
    stateOff: 'Der Check-in ist aus.',
    stateNotToday: 'Heute gibt es keinen Check-in.',
    stateConsentNeeded: 'Wartet auf das Ja von {name} auf der Tafel.',
    stateDeclined: '{name} möchte lieber nicht.',
    silenceNote: 'Keine Nachricht heißt nicht immer, dass alles gut ist.',
    emergencyNote: 'Kein Notrufdienst. Im Notfall: 112.',
    ack: 'Ich rufe kurz an',
    acked: '{label} ruft kurz an ({time})',
    ackStale: '{label} ruft seit {time} an, noch nicht bestätigt.',
    resolve: 'Alles in Ordnung',
    tzNote: '(Uhrzeit bei {name})',
    history: 'Letzte {n} Tage',
    historyKinds: {
        done: 'Alles gut',
        late: 'Später getippt',
        missing: 'Kein Tippen',
        paused: 'Pause',
        not_checked: 'Nicht geprüft',
        off: 'Kein Check-in',
    },
    pauses: 'Pausen',
    pauseAdd: 'Pause hinzufügen',
    pauseFrom: 'Von',
    pauseTo: 'Bis einschließlich',
    pauseMax: 'Höchstens {n} Tage. Länger weg? Dann schalte den Check-in aus.',
    inviteInUse: 'Diese Adresse hat schon eine Einladung als Mitbewohner. Zieh sie zuerst zurück.',
    pauseLimit: 'Wer mitschaut, kann insgesamt höchstens {n} Tage Pause setzen, und nicht weiter als {n} Tage im Voraus.',
    someone: 'jemand',
    pauseHint: 'Zum Beispiel im Urlaub oder bei einem Besuch. Wir speichern keinen Grund.',
    pauseLine: '{from} bis einschließlich {to} (gesetzt von {label})',
    pauseStop: 'Pause beenden',
    pauseNone: 'Keine Pause geplant.',
    offlineTitle: 'Was, wenn die Tafel offline ist?',
    offlineHelp: 'Hat die Tafel keine Verbindung, wird ein Tippen später gesendet. {name} kann auch die App auf dem Telefon benutzen.',
    outageTitle: 'Was, wenn AMUMIN eine Störung hat?',
    outageHelp: "Hat AMUMIN eine Störung, siehst du hier 'Heute nicht geprüft'. Keine Nachricht ist kein Beweis, dass alles gut ist.",
    circleTitle: 'Kreis',
    circleEmpty: 'Noch schaut niemand mit.',
    circleStatusInvited: 'Eingeladen',
    circleStatusPending: 'Wartet auf das Ja von {name}',
    circleStatusActive: 'Aktiv',
    circleStatusDeclined: 'Lieber nicht',
    roleRelative: 'Mitschauer',
    roleManager: 'Verwalter',
    remove: 'Aus dem Kreis nehmen',
    removeConfirm: '{label} aus dem Kreis nehmen? {label} sieht danach sofort nichts mehr.',
    removePauseNote: '{label} hat eine Pause bis {date} gesetzt. Diese Pause endet, wenn du {label} herausnimmst.',
    leave: 'Den Kreis verlassen',
    leaveConfirm: 'Den Kreis verlassen? Du siehst danach nichts mehr vom Zuhause von {name}.',
    resend: 'Erneut senden',
    rightsNeedYes: 'Mehr Rechte? Dann fragt die Tafel {name} zuerst um ein Ja.',
    newWatcher: '{label} schaut jetzt mit: {rights}.',
    inviteSomeone: 'Jemanden einladen',
    seniorNoCircle: 'Es gibt noch niemanden, der einen Hinweis bekommen kann.',
    switchToCare: "Wird 'Zuhause mit Familie, die mitschaut'",
    selfButton: 'Alles gut',
    selfConsentIntro: 'Lies das in Ruhe. Du entscheidest.',
    selfWithdraw: 'Mit dem Check-in aufhören',
    approveTitle: '{label} möchte mitschauen',
    approveYes: 'Ja, das ist gut',
    approveNo: 'Lieber nicht',
    myCircleTitle: 'Mein Kreis',
    myRights: 'Was du im Zuhause von {name} siehst',
    myRightsNone: 'Du siehst noch nichts: {name} sagt zuerst selbst Ja auf der Tafel.',
    pushCheckIn: 'Täglicher Check-in',
    pushCheckInQuiet: 'Auch während der Ruhezeiten (sonst kommt der Hinweis danach)',
    inviteTitle: 'Einladung zum Mitschauen',
    inviteBody: '{inviter} lädt dich ein, bei {household} mitzuschauen, als "{label}".',
    inviteRights: 'Du darfst:',
    inviteAcceptExisting: 'Annehmen',
    inviteLoginFirst: 'Melde dich zuerst mit {email} an und öffne den Link dann erneut.',
    inviteAcceptNew: 'Konto erstellen und annehmen',
    invitePassword: 'Wähle ein Passwort',
    inviteWrongEmail: 'Diese Einladung ist für eine andere E-Mail-Adresse.',
    inviteInvalid: 'Diese Einladung ist ungültig oder abgelaufen.',
    inviteAccepted: 'Geschafft. Die Tafel fragt zuerst, ob das okay ist. Danach siehst du es hier.',
    inviteToApp: 'Zur App',
    notEmergencyShort: 'Dies ist kein Notrufdienst.',
    errorGeneric: 'Das hat nicht geklappt. Versuche es noch einmal.',
};
//# sourceMappingURL=careApp.de.js.map